export const isEmbeddedSignEnabled = () => import.meta.env.VITE_ENABLE_EMBEDDED_SIGN === 'true'
